// extracted by mini-css-extract-plugin
module.exports = {"downloadAppModal":"downloadAppModal__d7qgX","text":"text__42Vid","image":"image__21aVF"};